'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import t from 'tiny-warning';
import { useZoomControlsContext } from './zoom-controls.context.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ZoomControlsValue = renderWithRef('ZoomControlsValue', null, (i, m)=>{
    let b = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('ZoomControlsValue', i, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: getDeprecatedI18nPropMessage(b)
        },
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(b)
        }
    ]);
    let { visuallyHiddenLabel: f, accessibleText: d, value: y, children: O } = i, j = _object_without_properties(i, [
        "visuallyHiddenLabel",
        "accessibleText",
        "value",
        "children"
    ]), { setId: _ } = useZoomControlsContext(), w = useId(j.id);
    useEffect(()=>{
        _(w);
    }, [
        w,
        _
    ]);
    let h = b && y ? b.formatNumber(y, {
        style: 'unit',
        unit: 'percent'
    }) : '', v = null != d ? d : f;
    return b && !v && (v = b.t('zoom-controls-value.accessible-text-for-zoom-value', {
        value: h
    })), t(!(b && !y), '[ZoomControlsValue] Passing children instead of "value" prop is not recommended when using i18n context. And this will be removed in v4. Please use the "value" prop for proper localization and accessibility support.'), jsxs(RenderComp, {
        root: "span",
        forwardedRef: m,
        classNames: [
            'swan-zoom-controls-value'
        ],
        props: _object_spread_props(_object_spread({}, j), {
            id: w,
            'aria-live': 'polite',
            'aria-atomic': 'true'
        }),
        children: [
            jsx(VisuallyHidden, {
                children: v
            }),
            jsx("span", {
                "aria-hidden": !!h,
                children: h || O
            })
        ]
    });
});

export { ZoomControlsValue };
